<template>
  <el-dialog v-bind="$attrs" v-on="$listeners" width="500px" :close-on-click-modal="false" @close="onClose">
    <div class="mb-5 text-center">
      <i class="el-icon-warning-outline text-[30px] font-bold text-primary"></i>
    </div>
    <div class="mb-3 text-center text-sm font-bold" v-if="phoneAuth">认证手机：（{{ phonePrefix }}）{{ phone }}</div>
    <div class="mb-3 text-center text-sm font-bold" v-else>您还未认证手机号</div>
    <div class="mb-5 text-center text-sm leading-6">
      为确保信息真实性，为用户提供更友好的平台， <br />仅限北美手机号（+1）认证的会员发布信息。
    </div>
    <div class="text-center">
      <el-button type="primary" v-if="phoneAuth" @click="updatePhone">立即修改手机号</el-button>
      <el-button type="primary" v-else @click="createPhone">立即认证手机号</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { hostBuild } from '@/utils/utils';
export default {
  name: 'DialogUnauth',
  computed: {
    phone() {
      return this.$store.getters.user.phone;
    },
    phonePrefix() {
      return this.$store.getters.user.phonePrefix;
    },
    phoneAuth() {
      return this.$store.getters.user.phoneAuth;
    },
  },
  methods: {
    onClose() {
      if ((this.isAuth && this.prefix != '+1') || !this.isAuth) {
        this.$emit('update:visible', false);
        this.$router.replace('/');
      }
    },
    updatePhone() {
      location.href = hostBuild(`/center/account?redirect=${location.href}`, 'home');
    },
    createPhone() {
      location.href = hostBuild(`/auth?redirect=${location.href}`, 'account');
    },
  },
};
</script>
